import { useState, useContext, useEffect } from "react";
import DataTable from "react-data-table-component";
import { getClients } from "../../services/api";
import { AuthContext } from "../../App";

function Clients() {
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const {
    settingsFormActive,
    setSettingsFormActive,
    setEvent,
    setSettingsForm,
    settingsForm,
  } = useContext(AuthContext);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.organisation_name,
      sortable: true,
    },
  ];

  const handleRowClicked = (event) => {
    setSettingsForm("client");
    setEvent(event);
    setSettingsFormActive(true);
  };

  useEffect(() => {
    getClients().then(async (res) => {
      setData(res);
      console.log(res);
    });
    console.log("client component rendered");
  }, [settingsFormActive]);

  const handleSearch = (event) => {
    console.log(event.target.value);
    setSearchText(event.target.value);
  };

  const filteredData = data.filter((item) =>
    Object.keys(item).some(
      (key) =>
        item[key] !== null &&
        item[key].toString().toLowerCase().indexOf(searchText.toLowerCase()) >
          -1
    )
  );

  const handleAddClick = () => {
    setSettingsForm("client");
    setEvent(null);
    setSettingsFormActive(true);
  };

  return (
    <div>
      <div className="settings-component-header">
        <input
          type="text"
          value={searchText}
          onChange={handleSearch}
          placeholder="Search"
          style={{
            marginLeft: 20,
            width: 300,
          }}
        />
        <button className="booking-button" onClick={handleAddClick}>
          add
        </button>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover={true}
        striped={true}
        pointerOnHover={true}
        onRowClicked={(event) => handleRowClicked(event)}
        direction="auto"
        fixedHeader
        fixedHeaderScrollHeight="530px"
        persistTableHead
        responsive
        dense
      />
    </div>
  );
}

export default Clients;
